import { useMemo } from 'react';
import type { CommandContext } from '../core/commands';
import { useEditorStore } from '../store/editorStore';
import { usePlaybackStore } from '../store/playbackStore';

export function useCommandContext(): CommandContext {
  return useMemo(() => ({
    split: () => useEditorStore.getState().splitSelection(),
    deleteSelection: (ripple) => useEditorStore.getState().removeSelection(ripple),
    duplicate: () => useEditorStore.getState().duplicateSelection(),
    addMarker: () => useEditorStore.getState().addMarker(),
    addText: () => { useEditorStore.getState().addLayer('text'); },
    addShape: () => { useEditorStore.getState().addLayer('shape'); },
    addScene3D: () => { useEditorStore.getState().addLayer('scene3d'); },
    togglePlayback: () => usePlaybackStore.getState().toggle(),
    toggleSnapping: () => useEditorStore.getState().toggleSnapping(),
    setWorkspace: (workspace) => useEditorStore.getState().setWorkspace(workspace),
    undo: () => useEditorStore.getState().undo(),
    redo: () => useEditorStore.getState().redo(),
    showExport: () => useEditorStore.getState().setModal('export'),
    showImport: () => useEditorStore.getState().setLeftPanel('media')
  }), []);
}
